<template>
    <v-container fluid grid-list-md>
        <v-layout justify-center wrap>
            <v-flex xs12>
                <password></password>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import Password from '../components/common/Password';

    export default {
        components: {
            'password': Password
        },
        mounted() {
        }
    }
</script>
